import { Field } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import EyeCloseIcon from "../../assets/icons/eye-close-icon";
import EyeOpenIcon from "../../assets/icons/eye-open-icon";
import StarIcon from "../../assets/icons/req-star";
import ErrorMsg from "./error-msg";
import "./form.css";
import errorToast from "../helper-components/error-toast";

export default function InputField({
  inputClass = "",
  containerClass = "mb-2 position-relative",
  parentClass = "flex items-center m-0 p-0 w-full",
  labelClass = "whitespace-nowrap flex text-[var(--input-label-color)] text-[length:var(--input-label-font-size)] font-[var(--input-label-font-weight)]",
  defaultInputClass = "min-h-[42px] rounded-[8px]  px-2  bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--input-font-weight)] rounded input-field-no-spin-buttons placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:border-[var(--input-focus)] focus:text-[var(--input-color)] focus:bg-[var(--input-bg)] ",
  errorBorder = "border border-[var(--input-error-border)]",
  inputBorder = "border border-[var(--input-border)]",
  max = "",
  min = 0,
  isDisabled = false,
  name = "",
  placeholder = "Enter your email address",
  label = "Email Address",
  id,
  type = "text",
  errMsgContainerClass = "",
  isContainer = true,
  isUnit = false,
  unitType = localStorage?.getItem("currency") ?? "₹",
  unitPosition = "left",
  isPasswordEye = false,
  passwordEyeStyle = { top: "44%" },
  autoComplete = "",
  unitClassName = "",
  children,
  isRequired = false,
  labelWidth = "10rem",
  prefixicon = "",
  allowSpecial=false,
  maxValue, // Add this prop
  handleChange = (e, field) => {
    field.onChange(e);
  },

  autoFocus = false,
  maxLength = 1000,
  onKeyDown = (event) => {
    const validKey = /^[a-zA-Z0-9\s]+$/;
    if (!allowSpecial && !validKey.test(event.key) && event.key !== "Backspace") {
      event.preventDefault();
      errorToast("Special Characters are blocked");
    } else if (!allowSpecial && (event.key === "-" || event.key === "e") && type === "number") {
      event.preventDefault();
      errorToast("Special Characters are blocked");
    }
  },
  onBlur,
  unitContainerClass = "flex unit_input__container",
  unitContainerErrorClass = "flex unit_input_container__error",
  passwordEyeClass = "position-absolute  end-0 translate-middle  cursor_pointer",
  inputRef,

  // 👉 NEW: right icon (React component/element)
  rightIcon = null,
  rightIconClass = "absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer flex items-center",
  rightIconStyle = {},
}) {
  const finalInputClass = inputClass
    ? `${defaultInputClass} ${inputClass}`
    : defaultInputClass;

  const Container = isContainer ? "div" : Fragment;
  const UnitContainer = isUnit ? "div" : Fragment;
  const PasswordEyeContainer = isPasswordEye || rightIcon ? "div" : Fragment;
  const [passInputType, setPassInputType] = useState("password");

  const hasRightAdornment = isPasswordEye || rightIcon;

  useEffect(() => {
    if (autoFocus) {
      if (inputRef?.current) {
        inputRef?.current?.focus();
      }
    }
  }, []);

  return (
    <Container
      {...(isContainer && containerClass ? { className: containerClass } : {})}
    >
      <Field className="no-arrows" name={name}>
        {({ field, meta }) => (
          <div className={parentClass}>
            {label && (
              <label
                style={{
                  minWidth: labelWidth,
                }}
                {...(id ? { htmlFor: id } : {})}
                className={`${labelClass} flex  flex-nowrap`}
              >
                <span className="flex items-center gap-2">
                  {prefixicon}
                  {label}
                </span>
                {isRequired && (
                  <span className="ml-2">
                    <StarIcon />
                  </span>
                )}
              </label>
            )}
            <UnitContainer
              {...(unitContainerClass && isUnit
                ? {
                    className: `  ${
                      meta.touched && meta.error
                        ? unitContainerErrorClass
                        : unitContainerClass
                    } ${
                      unitPosition === "right" ? "flex-row-reverse" : ""
                    } w-full`,
                  }
                : {})}
            >
              {isUnit && (
                <div
                  className={`d-flex justify-content-center align-items-center font_poppins mt-1 ${
                    unitPosition === "right" ? "flex-row-reverse" : ""
                  }`}
                >
                  <span
                    className={` fw_500 text-sm align-middle primary_color ${unitClassName} ${
                      unitPosition === "right" ? "ms-1" : "me-1"
                    }`}
                  >
                    {unitType}
                  </span>{" "}
                  {unitPosition !== "image" && (
                    <span className={`input-vr mx-2`}></span>
                  )}
                </div>
              )}
              <PasswordEyeContainer
                {...(isPasswordEye || rightIcon
                  ? {
                      className: `position-relative relative w-full`,
                    }
                  : {})}
              >
                <input
                  min={min}
                  max={max}
                  maxLength={maxLength}
                  onWheel={(e) => e.target.blur()}
                  ref={inputRef}
                  {...(isDisabled ? { disabled: true } : {})}
                  {...(autoComplete ? { autoComplete: autoComplete } : {})}
                  type={type === "password" ? passInputType : type}
                  {...field}
                  placeholder={placeholder}
                  {...(id ? { id: id } : {})}
                  className={`${
                    isUnit
                      ? `${finalInputClass} focus_outline__none w-100 ${
                          hasRightAdornment ? "pr-10" : ""
                        }`
                      : `${
                          meta.touched && meta.error ? errorBorder : inputBorder
                        } ${
                          autoFocus
                            ? "focus:border-focus-color border"
                            : "no-arrows"
                        } ${finalInputClass} input-field-no-spin-buttons w-full ${
                          hasRightAdornment ? "pr-10" : ""
                        }`
                  } ${
                    isDisabled
                      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                      : ""
                  }`}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (
                      type === "number" &&
                      typeof maxValue === "number" &&
                      maxValue > 0
                    ) {
                      const numericValue = parseFloat(value);
                      if (!isNaN(numericValue) && numericValue > maxValue) {
                        const syntheticEvent = {
                          ...e,
                          target: {
                            ...e.target,
                            value: maxValue.toString(),
                          },
                        };
                        handleChange(syntheticEvent, field);
                        field.onChange(syntheticEvent);
                        return;
                      }
                    }

                    if (value.length <= maxLength) {
                      handleChange(e, field);
                      field.onChange(e);
                    }
                  }}
                  onBlur={onBlur}
                  onKeyDown={onKeyDown}
                />

                {/* Password eye (unchanged) */}
                {isPasswordEye &&
                  (passInputType === "password" ? (
                    <button
                      style={passwordEyeStyle}
                      type="button"
                      className={`${passwordEyeClass} `}
                    >
                      <EyeCloseIcon onClick={() => setPassInputType("text")} />
                    </button>
                  ) : (
                    <button
                      type="button"
                      style={passwordEyeStyle}
                      className={`${passwordEyeClass} border-0`}
                    >
                      <EyeOpenIcon
                        onClick={() => setPassInputType("password")}
                      />
                    </button>
                  ))}
                {rightIcon && (
                  <div style={rightIconStyle} className={rightIconClass}>
                    {rightIcon}
                  </div>
                )}
              </PasswordEyeContainer>
            </UnitContainer>
          </div>
        )}
      </Field>
      <ErrorMsg containerClass={errMsgContainerClass} name={name} />
      {children}
    </Container>
  );
}
